import { combineReducers } from 'redux';
import companyStatistic from './companyStatistic';

export default combineReducers({ companyStatistic });
